import mergeProps from '@/utils/mergeProps';
import { StandaloneBanner } from 'base/components/Banner';

const AllasStandaloneBanner: typeof StandaloneBanner = (props) => {
  return <StandaloneBanner {...mergeProps({ link: { href: '/korsord-och-spel' } }, props)} />;
};

export default AllasStandaloneBanner;
